import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-6xl mx-auto px-4 py-10">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-8">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-3">
              <img src="/qmax-logo.png" alt="QMAX" className="w-10 h-10 rounded-lg" />
              <span className="text-xl font-bold">QMAX</span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">Official mobile apps for QMAX tile stores.</p>
          </div>

          <div>
            <h3 className="font-semibold mb-3 text-sm">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li><a href="#apps" className="text-gray-400 hover:text-white transition-colors">Apps</a></li>
              <li><a href="#features" className="text-gray-400 hover:text-white transition-colors">Features</a></li>
              <li><a href="#download" className="text-gray-400 hover:text-white transition-colors">Download</a></li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold mb-3 text-sm">Legal</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/terms-of-use" className="text-gray-400 hover:text-white transition-colors">Terms</Link></li>
              <li><Link to="/privacy-policy" className="text-gray-400 hover:text-white transition-colors">Privacy</Link></li>
              <li><Link to="/cookie-policy" className="text-gray-400 hover:text-white transition-colors">Cookies</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold mb-3 text-sm">Contact</h3>
            <p className="text-gray-400 text-sm">info@starsolutions.biz</p>
            <p className="text-gray-400 text-sm mt-1">qmaxonline.com</p>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-6 flex flex-col sm:flex-row justify-between items-center gap-2 text-xs text-gray-500">
          <p>© {new Date().getFullYear()} QMAX Online</p>
          <p>Powered by <span className="text-blue-400">SANIBIZ</span> • <span className="text-purple-400">Star Solutions</span></p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
